import React from 'react'
import { useEffect } from 'react'
import prpBanner from './../../../../../assets/images/blogs/prp blog-21-07-2025.jpg';
import { useNavigate } from 'react-router-dom';
import favicon from "./../../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PrpBlog = () => {
    const handleDownloadPdf = () => {
  const input = document.querySelector('.dentalblog'); // Use the main container class
  
  html2canvas(input, { 
    scale: 2,
    useCORS: true,
    logging: false 
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save('H-Cura_PRP_Hair_Treatment.pdf');
  }).catch(error => {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  });
};
      let navigate = useNavigate()

          useEffect(() => {
               document.title = "PRP Is the Fertilizer | PRP Hair Treatment at H-Cura";
               const metaDescription = document.querySelector("meta[name='description']");
               if (metaDescription) {
                 metaDescription.setAttribute(
                   "content",
                   "Discover how PRP therapy acts like fertilizer for your scalp, stimulating natural hair regrowth. Visit H-Cura Clinic in Bangalore & Chennai for expert PRP hair restoration."
                 );
               }
               const metaKeywords = document.querySelector("meta[name='keywords']");
               if (metaKeywords) {
                 metaKeywords.setAttribute(
                   "content",
                   "PRP hair treatment, PRP therapy for hair, platelet rich plasma hair, PRP hair restoration, PRP injection for hair loss, hair loss treatment, PRP vs hair transplant, PRP hair regrowth, best PRP clinic in Bangalore, PRP treatment Chennai, PRP for male pattern baldness, PRP for female hair loss, hair thinning solution, PRP results before and after, H-Cura PRP therap"
                 );
               }
                // Set canonical link
                const existingCanonical = document.querySelector("link[rel='canonical']");
                if (existingCanonical) {
                  existingCanonical.setAttribute("href", "https://www.h-cura.com/prp-hair-growth-therapy-scalp-fertilizer");
                } else {
                  const canonicalLink = document.createElement("link");
                  canonicalLink.setAttribute("rel", "canonical");
                  canonicalLink.setAttribute("href", "https://www.h-cura.com/prp-hair-growth-therapy-scalp-fertilizer");
                  document.head.appendChild(canonicalLink);
                }
                // Set favicon
             const existingFavicon = document.querySelector("link[rel='icon']");
             if (existingFavicon) {
               existingFavicon.setAttribute("href", favicon);
             } else {
               const faviconLink = document.createElement("link");
               faviconLink.setAttribute("rel", "icon");
               faviconLink.setAttribute("type", "image/x-icon");
               faviconLink.setAttribute("href", favicon);
               document.head.appendChild(faviconLink);
             }
             
             }, []);

             

     const handleBookAppointment = () => {
    navigate('/bookconsultation'); // Use navigate to redirect to the booking page
   };
  return (
   <>
   <div className="dentalblog">
      <div className="dentalblog-banner">
  <img src={prpBanner} alt="Dental Care Banner" />
  <div className="dentalblog-banner-overlay">
    <h1>If Your Scalp Was a Garden, PRP Is the Fertilizer</h1>
    <h2> Your Path to Healthier Hair</h2>
    <button 
      className="dentalblogbook-appointment-btn" 
      onClick={handleBookAppointment}
    >
      Book Appointment
    </button>
  </div>
</div>

        
        <div className="dentalblog-container">
          <div className="dentalblog-intro">
            <p>Imagine running your fingers through fuller, healthier hair without worrying about thinning patches or excessive shedding. Sounds like a dream, right? The secret lies in PRP hair treatment—a natural and highly effective way to revive dormant follicles and restore your confidence.</p>
            <p>
                At H-Cura Multispeciality Clinic, with locations in Jayanagar, Bangalore and Gerugambakkam, Chennai, we care about your hair as much as you do. Let’s explore science-backed habits to protect your hair and maximize the results of PRP therapy.</p>
          </div>
          
          <div className="dentalblog-section">
            <h2>✅ Why is PRP Prevention Important?</h2>
            <p>PRP for hair loss nourishes follicles before excessive hair fall begins. Early care strengthens roots, slows thinning, and keeps your scalp in optimal condition for long-term hair health.</p>
            <p>For residents in Bangalore and Chennai, our specialists recommend starting platelet-rich plasma hair restoration early for maximum results.</p>
          </div>
          
          <div className="dentalblog-tips">
            <div className="dentalblog-tip-card">
              <h3>1️⃣ Start Early When You Notice Hair Thinning</h3>
              <p>Catching hair loss early? PRP injection gives hair a better chance to stimulate dormant follicles and restore thickness.</p>
              <p className="tip-highlight">✅ Pro Tip: In Jayanagar, Bangalore? Book a scalp evaluation to see if you’re a candidate for PRP hair treatment for male pattern baldness or PRP for female hair loss.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>2️⃣ Commit to the Full PRP Plan</h3>
              <p>PRP therapy results before and after are most visible when you complete 3–4 sessions.</p>
              <p className="tip-highlight">✅ Nearby Tip: Visit our PRP experts in Valasaravakkam, Chennai to get a customized PRP hair therapy Chennai plan.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>3️⃣ Pair PRP with Advanced Options</h3>
              <p>Enhance results with PRP +  ,PRP with collagen induction therapy,PRP and LLLT hair regrowth</p>
              <p className="tip-highlight">Wondering about PRP vs hair transplant or PRP Our specialists will guide you on the best choice.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>4️⃣ Follow a Nutrient-Rich Diet for Hair Health</h3>
              <p>PRP stimulates growth, but your body needs iron, zinc, biotin, and protein for strong hair. A healthy diet boosts PRP effectiveness for hair regrowth.</p>
              <p className="tip-highlight">✅ Ask our specialists for a diet chart to enhance blood plasma treatment for hair loss results.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>5️⃣ Avoid Heat Styling Post-PRP</h3>
              <p>Post-PRP, your scalp is healing. Give scalp  the downtime for healing by avoiding heat styling and chemical treatments.</p>
              <p className="tip-highlight">✅ Bonus Tip: Air-dry your hair and use natural oils while enjoying Bangalore or Chennai’s monsoon season.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>6️⃣ Massage Your Scalp Regularly</h3>
              <p>Gentle scalp massages help platelet-rich plasma for hair restoration distribute evenly.</p>
              <p className="tip-highlight">✅ Learn massage techniques from our experts in Jayanagar, Bangalore.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>7️⃣ Don’t Skip Follow-Ups</h3>
              <p>Stay consistent and track your progress at H-Cura’s PRP hair clinic near me for the best outcome.</p>
              <p>✅ Pro Tip: Set reminders for your sessions and track results with clinic photo logs.  </p>
            </div>
          </div>
          
          <div className="dentalblog-cta">
            <h2>📞 Book Your Appointment Now</h2>
            <p>👉 Call: <a href="tel:+918870001377">+91 88700 01377</a></p>
            <p>📍 Visit us in Bangalore (Jayanagar) or Chennai (Tambaram , Gerugambakkam & Valasaravakkam)</p>
          </div>
          
        
          
          <div className="dentalblog-testimonials">
            <h2> Why Choose H-Cura for PRP Hair Treatment?</h2>
            <p>At H-Cura, our specialists in Bangalore and Chennai offer advanced PRP hair treatment near me that’s natural, safe, and effective.</p>
            <div className="testimonial-container">
              <div className="testimonial">
                <p>💬 “I got my PRP sessions done at H-Cura in Jayanagar, and the results were amazing—less hair fall and visible growth!” – A client from Bangalore</p>
              </div>
              <div className="testimonial">
                <p>💬 “If you’re in Chennai searching for PRP therapy results before and after, H-Cura in Valasaravakkam is the answer.”</p>
              </div>
            </div>
          </div>
            <div className="dentalblog-summary">
            <h2>🌟 Quick Hair Regrowth Checklist with PRP</h2>
            <ul>
              <li>✅ Start with a personalized scalp analysis</li>
              <li>✅ Undergo safe PRP injections benefits for hair</li>
              <li>✅ Maintain a healthy diet post-PRP</li>
              <li>✅ Follow gentle care routines and sun protection</li>
              <li>✅ Book regular follow-ups at H-Cura</li>
            </ul>
            {/* <p>By practicing these simple daily habits, you're not just preventing cavities—you're investing in a confident, pain-free smile.</p> */}
          </div>
        </div>
      </div>
{/* <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Blog as PDF
            </button>
          </div> */}

   
   
   </>
  )
}

export default PrpBlog